<template>
  <b-modal
    id="master-fr-modal-confirmation-delete"
    size="md"
    centered
    :title="`${$t('global.object.alert')}`"
  >
    <b-card class="mc-card mc-card__setting mc-card__setting--delete-photo">
      <div class="d-flex justify-content-center align-items-center">
        {{ confirmationMessage }}
      </div>
    </b-card>
    <template #modal-footer="{ cancel }">
      <b-row class="mc-modal__filter-footer mx-0">
        <b-col sm="12" md="12" class="mc-modal__filter-footer-btn mt-0">
          <McButton
            :data-me="`master-fr-btn-close-modal-confirmation-delete-${employee?.userId}`"
            variant="outline-primary"
            class="me-2"
            :text="$t('global.action.close')"
            @click="cancel()"
          />
          <McButton
            :data-me="`master-fr-btn-confirm-modal-confirmation-delete-${employee?.userId}`"
            variant="primary"
            class="me-2"
            :text="$t('global.action.apply')"
            :loading="isLoading"
            @click="handleConfirm()"
          />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import { UPDATE_EMPLOYEE } from '@/services/api/master/employees'

export default {
  name: 'ModalConfirmationDelete',
  components: {
    McButton,
  },
  data() {
    return {
      employee: null,
      type: 'photo', // 'photo' | 'rfid'
      isLoading: false,
    }
  },
  computed: {
    confirmationMessage() {
      return this.$t('rfidAndFacerecognition.confirmationDeleteIdentity')
    },
  },
  methods: {
    show(employee, type = 'photo') {
      this.isLoading = false
      this.employee = employee
      this.type = type
      this.$bvModal.show('master-fr-modal-confirmation-delete')
    },
    hide() {
      this.isLoading = false
      this.$bvModal.hide('master-fr-modal-confirmation-delete')
    },
    handleConfirm() {
      if (this.type === 'photo') {
        this.deletePhoto()
      } else {
        this.deleteRfid()
      }
    },

    async deletePhoto(overrideEmployee = null) {
      const employee = overrideEmployee ?? this.employee
      const hasRfid = employee?.rfid?.rfid
      const oldVehicles = employee?.vehicles
      const newVehicles = hasRfid ? oldVehicles : []

      this.isLoading = true
      try {
        const res = await this.$apollo.mutate({
          mutation: UPDATE_EMPLOYEE,
          variables: {
            input: {
              userId: employee.userId,
              oldData: {
                photograph: employee.photograph,
                identification: {
                  vehicleIds: oldVehicles,
                  rfid: hasRfid || null,
                },
              },
              newData: {
                photograph: null,
                identification: {
                  vehicleIds: newVehicles,
                  rfid: hasRfid || null,
                },
              },
            },
          },
        })

        if (!res.data.updateEmployee.isSuccessful) {
          this.$mcToast.error(
            res.data.updateEmployee.message || this.$t('global.alert.text.failed')
          )
          return
        }

        this.$mcToast.success(this.$t('rfidAndFacerecognition.flashMessage.faceRecognitionDeleted'))
        this.$emit('delete-success')
      } catch (error) {
        console.error('Error deleting photo:', error)
        this.$mcToast.error(this.$t('global.alert.text.failed'))
      } finally {
        this.hide()
      }
    },

    async deleteRfid() {
      const { employee } = this
      const hasRfid = employee?.rfid?.rfid
      const oldVehicles = employee?.vehicles || []

      this.isLoading = true
      try {
        const res = await this.$apollo.mutate({
          mutation: UPDATE_EMPLOYEE,
          variables: {
            input: {
              userId: employee.userId,
              oldData: {
                identification: {
                  rfid: hasRfid || null,
                  vehicleIds: oldVehicles,
                },
              },
              newData: {
                identification: {
                  rfid: null,
                  vehicleIds: [],
                },
              },
            },
          },
        })

        if (!res.data.updateEmployee.isSuccessful) {
          this.$mcToast.error(
            res.data.updateEmployee.message || this.$t('global.alert.text.failed')
          )
          return
        }

        this.$mcToast.success(res.data.updateEmployee.message)
        this.$emit('delete-success')
      } catch (error) {
        console.error('Error deleting RFID:', error)
        this.$mcToast.error(this.$t('global.alert.text.failed'))
      } finally {
        this.hide()
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
